import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

/**
 * Legacy secure card collection — superseded by Stripe Checkout + Customer Portal in Settings.
 */
const SecurePaymentForm = () => {
  const navigate = useNavigate();

  useEffect(() => {
    navigate('/dashboard/settings?plans=1', { replace: true });
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-50 text-slate-600 text-sm">
      Redirecting to Plan & billing…
    </div>
  );
};

export default SecurePaymentForm;
